export default "/_next/static/3d4e56e7195b282ee9d52eb0d682286f.png";